import template from './cart-line.html';

export const iconStamp = (iconUrl, text) => `
    <p class="icon-stamp">
        <span class="icon-stamp__icon" aria-hidden="true">
            <img src="${iconUrl}" />
        </span>

        <span class="icon-stamp__text">
            ${text}
        </span>
    </p>
`;

export const listItem = (name, value) => {
    const bolded = name ? `<b>${name}</b>` : '';

    return `
        <li class="cart-line__list-item">
            ${bolded} ${value}
        </li> 
    `;
};

export default template;
